import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { IconWrapper } from './IconWrapper';

const ResponsibleGaming: React.FC = () => {
  return (
    <div className="bg-yellow-50 border-b-2 border-yellow-400 py-3 px-4">
      <div className="max-w-6xl mx-auto flex items-center justify-center flex-wrap gap-2 text-center">
        <IconWrapper icon={FaExclamationTriangle} className="text-yellow-600 flex-shrink-0" size={18} />
        <p className="text-sm text-gray-900">
          <strong>JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX:</strong> PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION. 
          RETROUVEZ NOS CONSEILS SUR{' '}
          <a 
            href="https://www.joueurs-info-service.fr/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary-600 hover:text-primary-700 underline font-semibold"
          >
            JOUEURS-INFO-SERVICE.FR
          </a>
          {' '}(09 74 75 13 13 - APPEL NON SURTAXÉ)
        </p>
      </div>
    </div>
  );
};

export default ResponsibleGaming;

